// extracted by mini-css-extract-plugin
module.exports = {"plats":"BlockPlatsFrais_plats__cIKQH","slide":"BlockPlatsFrais_slide__YoKst","feat":"BlockPlatsFrais_feat__JESUA","noTooltip":"BlockPlatsFrais_noTooltip__0dCwU"};